import { Plus } from "lucide-react"
import type { ReactNode } from "react"

import { cn } from "@/lib/utils"

interface FABProps {
  onClick?: () => void
  icon?: ReactNode
  className?: string
  "aria-label"?: string
}

export function FAB({
  onClick,
  icon,
  className,
  "aria-label": ariaLabel = "Create new",
}: FABProps) {
  return (
    <button
      onClick={onClick}
      aria-label={ariaLabel}
      className={cn(
        "flex shrink-0 items-center justify-center rounded-full",
        className,
      )}
      style={{
        width: 52,
        height: 52,
        background: "var(--fig-fab-bg)",
        boxShadow: "var(--fig-fab-shadow)",
        color: "var(--fig-text-active)",
      }}
    >
      {icon ?? <Plus size={22} strokeWidth={2.5} />}
    </button>
  )
}
